import type { JSX } from 'react';
import { Play } from 'lucide-react';
import {
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubTrigger,
  DropdownMenuSubContent,
} from '@/components/ui/dropdown-menu';
import type { CandidateStatus } from '../types/candidate.types';
import { CANDIDATE_STATUS_TRANSITIONS } from '../types/candidate.types';
import { STATUS_CONFIG } from './CandidateActions.utils';

interface CandidateStatusSubmenuProps {
  status: CandidateStatus;
  onStatusClick: (status: CandidateStatus) => void;
}

export function CandidateStatusSubmenu({
  status,
  onStatusClick,
}: CandidateStatusSubmenuProps): JSX.Element | null {
  const allowedTransitions = CANDIDATE_STATUS_TRANSITIONS[status];
  if (allowedTransitions.length === 0) return null;
  return (
    <>
      <DropdownMenuSeparator />
      <DropdownMenuSub>
        <DropdownMenuSubTrigger>
          <Play className="mr-2 h-4 w-4" />
          Change Status
        </DropdownMenuSubTrigger>
        <DropdownMenuSubContent>
          {allowedTransitions.map((s) => {
            const { icon: Icon, label } = STATUS_CONFIG[s];
            return (
              <DropdownMenuItem key={s} onClick={() => onStatusClick(s)}>
                <Icon className="mr-2 h-4 w-4" />
                {label}
              </DropdownMenuItem>
            );
          })}
        </DropdownMenuSubContent>
      </DropdownMenuSub>
    </>
  );
}
